/**
 * URL base da API.
 * - Dev (localhost): REACT_APP_API_URL ou :8000 (frontend e API em portas diferentes).
 * - Producao multi-tenant: string vazia → paths relativos (/api/...) na mesma origem
 *   (teste2.useambiental.com.br/api), para o gateway resolver o tenant pelo Host.
 */
export function resolveApiBaseUrl() {
  const configured = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  if (typeof window === 'undefined') {
    return configured;
  }
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return configured;
  }
  return '';
}

/** Monta URL absoluta ou relativa para fetch/axios fora da instancia api. */
export function apiPath(path) {
  const base = resolveApiBaseUrl();
  const p = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base.replace(/\/$/, '')}${p}` : p;
}
